import { gql } from 'apollo-angular';

export const FunnelGeneratePDFDocument = gql`
  query funnelGeneratePDF($funnelId: Int!, $logo: String!) {
    funnelGeneratePDF(funnelId: $funnelId, logo: $logo)
  }
`;
